import { useState, useEffect } from 'react';

/* Components */
import SkuNotice from '../AddSkuNotice';
import AddSkuMessage from '../AddSkuMessage';

/* Styles */
import styles from './addskunotice.module.scss';

/* Types */
import { SkuMessaging } from 'types/sku.types';

const AddTopSkuNotice = ({ bullets = [] }: Pick<SkuMessaging, 'bullets'>) => {
  const [visible, setVisible] = useState(false);

  const handleResize = () => {
    if (window.innerWidth > 1200) {
      setVisible(false);
      document.body.style.overflow = 'visible';
    }
  };

  const handleClick = () => {
    setVisible(!visible);
  };

  useEffect(() => {
    document.body.style.overflow = visible ? 'hidden' : 'visible';
  }, [visible]);

  useEffect(() => {
    window.addEventListener('resize', handleResize, { passive: true });

    return () => {
      window.removeEventListener('resize', handleResize);
      document.body.style.overflow = 'visible';
    };
  }, []);

  if (!(Array.isArray(bullets) && bullets.length > 0)) return null;

  return (
    <div className={styles.container}>
      {visible && <AddSkuMessage bullets={bullets} />}
      <SkuNotice handleClick={handleClick} visible={visible} />
      {visible && <button type="button" role="presentation" onClick={handleClick} className={styles.dimLayer} />}
    </div>
  );
};

export default AddTopSkuNotice;
